var VehicleSelectorV2 = function($container, selectedSteps) {
    var _that = this;

    // input validation is good
    if ($container.length === 0) {
        console.error('VehicleSelectorV2 error: $container element not found');
    }

    this.stepSelections = ( selectedSteps || selectedChatVehicleSteps.slice(0) );
    this.$dropdownContainer = $container.find('.vehicle-selector-stepwise-dropdowns');

    // Entries are {number: '', value: ''}
    this.steps = [];
    this.vehicleCompleteCallback = function() {};
    this.hasSelectedVehicleCallback = function() {};
    this.hasNoSelectedVehicleCallback = function() {};
    this.hasPartialVehicleSelected = function() {};

    this.init = function(force) {
        force = ( force || false );

        // Only run this for endeca cartridge mode and no force
        if(typeof currentPageURL === 'undefined' && !force) {
            return;
        }

        this.listen();

        if(this.stepSelections.length) {
            this.hasSelectedVehicleCallback();
            this.seedForm();
        } else {
            this.hasNoSelectedVehicleCallback();
        }
    };

    this.listen = function() {
        _that.$dropdownContainer.on('click', '.dropdown-item', function(e) {
            var $parent = $(this).parents('.dropdown');
            var $trigger = $parent.find('[data-toggle="dropdown"]');
            var value = $(this).attr('data-value');
            var label = $(this).html();
            var number = parseInt($trigger.attr('data-vstep'), 10);

            $trigger.find('.dropdown-label').html(label);
            $trigger.attr('data-value', value);
            $trigger.dropdown('toggle');

            // Find an existing array entry if it exists and update the value of it
            var exists = _that.steps.filter(function(step) {
               if(step.number === number) {
                   step.value = value;
                   return true;
               }
            });

            // If this step does not exist, add it to the current steps array.
            if(!exists.length) {
                _that.steps.push({number: number, value: value});
            } else {
                // Otherwise, we need to remove all steps after this one that exist and remove
                // the dom elements as well
                _that.steps = _that.steps.filter(function(step) {
                    if(step.number <= number) {
                        return true;
                    } else {
                        _that.$dropdownContainer.find('[data-vstep="'+step.number+'"]').parent().remove();
                    }
                });
            }

            _that.getNextStep();
        });
    };

    this.onVehicleSelected = function(fn) {
        this.vehicleCompleteCallback = fn;
        return this;
    };

    this.onHasSelectedVehicle = function(fn) {
        this.hasSelectedVehicleCallback = fn;
        return this;
    };

    this.onHasNoSelectedVehicle = function(fn) {
        this.hasNoSelectedVehicleCallback = fn;
        return this;
    };

    this.onHasPartialVehicleSelected = function(fn) {
        this.hasPartialVehicleSelected = fn;
        return this;
    };

    this.seedForm = function() {
        var makeSelection = this.stepSelections.shift();
        var make = makeSelection.split('::')[1];

        var $makeSelector = _that.$dropdownContainer.find('.dropdown:first');
        var label = $makeSelector.find('.dropdown-item[data-value="'+make+'"]').html();

        $makeSelector.find('.dropdown-label').html(label);
        $makeSelector.find('button').attr('data-value', make);

        this.steps.push({number: 1, label: label, value: make});
        this.getNextStep();
    };

    this.getNextStep = function() {
        $container.find('.loading').removeClass('d-none');

        var data = {
            'initing': this.stepSelections.length > 0 ? 1 : 0,
            'vehicleSelection': 1,
            'chatForm' : 'yes'
        };

        this.steps.forEach(function(step) {
            data['vstep_'+step.number] = step.value;
        });

        var _that = this;

        this.getStep(data)
            .done(function(response){
                var steps = _that.parseVehicleData(response);

                var lastStep = steps[steps.length - 1].key;
                var foundVehicle = false;
                steps.forEach(function(step) {
                    if(step.key === 'END') {
                        data.initing = 0;
                        var selectedVehicleConfigID;
                        if (step.options && step.options.length > 0) {
                            selectedVehicleConfigID = step.options[0].label;
                            foundVehicle = true;
                        }
                        _that.vehicleCompleteCallback(selectedVehicleConfigID);
                        return;
                    }
                    var $template = _that.$dropdownContainer.find('.dropdown:first').clone();
                    $template.find('.dropdown-label').html(step.label);
                    $template.find('.dropdown-menu').html('');
                    step.options.forEach(function(option) {
                        var content = '<span class="dropdown-item" data-value="'+option.val+'">'+option.label+'</span>';
                        $template.find('.dropdown-menu').append(content);
                    });

                    var stepSelection = _that.stepSelections.shift();

                    var stepNumber = step.key.split('::')[0].split('_')[1];
                    stepNumber = parseInt(stepNumber, 10);
                    var stepValue = '';
                    if(stepSelection) {
                        stepValue = stepSelection.split('::')[1];
                    }

                    if(stepSelection) {
                        var label =  $template.find('.dropdown-item[data-value="'+stepValue+'"]').html();
                        $template.find('.dropdown-label').html(label);
                        $template.find('[data-toggle="dropdown"]')
                            .attr('data-value', stepValue)
                            .attr('data-vstep', stepNumber);
                        _that.$dropdownContainer.append($template);
                        _that.steps.push({number: stepNumber, value: stepValue});
                    } else {
                        if(step.options.length === 1) {
                            $template.find('.dropdown-label').html(step.options[0].label);
                            $template.find('[data-toggle="dropdown"]')
                                .attr('data-value', step.options[0].val)
                                .attr('data-vstep', stepNumber);
                            _that.steps.push({number: stepNumber, value: step.options[0].val});
                        } else {
                            $template.find('.dropdown-label').html('Select ' + step.label);
                            $template.find('[data-toggle="dropdown"]')
                                .attr('data-value', '')
                                .attr('data-vstep', stepNumber);
                            _that.steps.push({number: stepNumber, value: null});
                        }
                        _that.$dropdownContainer.append($template);
                    }
                });

                $container.find('.loading').addClass('d-none');

                if(data.initing !== 0) {
                    _that.getNextStep();
                }
                else if ( ! foundVehicle ) {
                    _that.hasPartialVehicleSelected(response);
                }
            })
            .fail(function(thing) {
                console.error('VehicleSelectorV2 getStep failed', thing);
            });
    };

    this.getStep = function(data) {
        var deferred = $.Deferred();

        $.ajax({
            method: 'GET',
            url: '/includes/vehicleMap.cgi',
            data: data
        })
            .done(function(result) {
                deferred.resolve(result);
            })
            .fail(function(failure) {
                deferred.reject(failure);
            });

        return deferred.promise();
    };

    this.parseVehicleData = function(data) {
        var line = data.split('\n');

        // Store the steps that need to be generated
        var createdSteps = [];
        var options = 0;
        var currentStep = null;
        var currentStepNum = null;

        // Parse the AJAX response
        for (var i = 0; i < line.length; i++) {
            // If there are no characters, skip through this one.
            if (! line[i].length) {
                continue;
            }

            // Data format: vstep_2::90 Series::90 Series
            var lineElements = line[i].split('::');
            var currentLine = lineElements[0];
            var currentLineValue = lineElements[2];
            var currentLineDisplay = lineElements[1];

            // There are more options so let's compile them in a neat format!
            if (currentLine !== currentStep) {
                // This line is not logged in our currentSteps array so let's put it there!
                options = 0; // Reset counter
                currentStepNum = (currentStepNum === null ? 0 : currentStepNum + 1);
                currentStep = currentLine;

                createdSteps[currentStepNum] = {
                    key: currentStep,
                    options: []
                };
            }

            // Let's put the options in there now.
            if (currentLineValue === 'n') {
                // This is the label of the options.
                createdSteps[currentStepNum].label = currentLineDisplay;
            } else {
                createdSteps[currentStepNum].options.push({
                    val: currentLineValue,
                    label: currentLineDisplay
                });
            }
            options++;
        }

        return createdSteps;
    };

    this.getVehicleUrl = function() {
        var data = {};
        this.steps.forEach(function(step) {
            data['vstep_'+step.number] = step.value;
        });

        var deferred = $.Deferred();

        $.ajax({
            method: 'GET',
            url: '/selectVehicleUrl/',
            data: data
        })
            .done(function(result) {
                deferred.resolve(result);
            })
            .fail(function(failure) {
                deferred.reject(failure);
            });

        return deferred.promise();
    }

    this.getResetVehicleUrl = function() {
        var data = {};

        var deferred = $.Deferred();

        $.ajax({
            method: 'GET',
            url: '/selectVehicleUrl/?reset=1',
            data: data
        })
            .done(function(result) {
                deferred.resolve(result);
            })
            .fail(function(failure) {
                deferred.reject(failure);
            });

        return deferred.promise();
    }

    this.getSelectedOptionsString = function() {
        var parts = [];
        _that.$dropdownContainer.find('.dropdown').each(function(i, el) {
            parts.push($(el).find('.dropdown-label').text());
        });
        return parts.join(' ');
    }
};
